// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__279IR","newExpiryDate":"styles_newExpiryDate__1YYZH","footer":"styles_footer__Epq9C"};